import React, { Component } from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import LogoSrc from "src/img/MSIG Logo Horizontal.png";
import AISLogo from "src/js/AISLogo.js";
import LanguageChange from "src/js/LanguageChange.js";

class HeaderLogo extends Component {

    render() {
        return (
            <Row id="logo-grid">
                <Col className="logo-child" id="horizontalMSIG" md={3} sm={3} xs={5}>
                    <Image className="companyLogo" src={LogoSrc} responsive />
                </Col>
                <Col className="logo-child" id="aioi-logo" md={3} sm={3} xs={7}>
                    <AISLogo />
                </Col>
                <LanguageChange />
            </Row>
        );
    }
}

export default HeaderLogo;



// WEBPACK FOOTER //
// ./src/js/HeaderLogo.js